import { View, Text, Image } from 'react-native'
import React from 'react'
import { Images } from '../../../../constants/Images'
import { Colors } from '../../../../constants/Colors'

interface IEquipamentCard {
    id: string;
}

const EquipamentCard = ({id}: IEquipamentCard) => {
  return (
    <View
    style={{
        height: 496,
        width: '100%',
        borderWidth: 1,
        borderColor: Colors.GrayPallete.lightgrayTwo,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center'
    }}
    >
        
        <Text
        style={{
            fontSize: 16,
            lineHeight: 19,
            textAlign: 'center',
            alignSelf: 'center',
            fontFamily: 'TCCC-UnityText Bold',
            color: 'black',
            maxWidth: 160,
            marginBottom: 30
        }}
        >Geladeira freezer 2 portas</Text>
      <Image
      source={Images.cokeFreeze}
      style={{
        alignSelf: 'center'
      }}
      />
      <View
        style={{
            backgroundColor: Colors.RedPallete.red,
            height: 40,
            width: 40,
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            left: 10,
            top: 10,
            borderRadius: 3
            
        }}
        >
            <Text style={{
                color: 'white',
                fontSize: 14
            }}>{id}</Text>
        </View>
    </View>
  )
}

export default EquipamentCard